"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._ObjectIdentifier = {
    type: "structure",
    required: ["Key"],
    members: {
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        VersionId: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_ObjectIdentifier.js.map